import R from 'ramda';
import React, {PropTypes as pt} from 'react';
import classNames from 'classnames';

class Select extends React.Component {
    handleChange = e => this.props.onChange(e.target.name, e.target.value);

    render() {
        const {name, value, id, label, disabled, hasEmpty, error, horizontal} = this.props;
        const options = hasEmpty ? [{key: '', value: '–––––'}, ...this.props.options] : this.props.options;
        const optionMapper = item => (
            <option key={item.key} checked={value === item.key} value={item.key}>{item.value}</option>
        );

        const classes = classNames({
            'form-group': true,
            'has-error has-danger': !!error,
        });
        const labelClasses = classNames({
            'control-label': true,
            'col-md-4': horizontal,
        });
        const formControlWrapperClasses = classNames({
            'col-md-8': horizontal,
        });
        const selectClasses = classNames({
            'form-control': true,
            'is-invalid': !!error,
        });
        const formattedError = Array.isArray(error) ? error[0] : error;

        return (
            <div className={classes}>
                {label && <label htmlFor={id} className={labelClasses}>{label}</label>}
                <div className={formControlWrapperClasses}>
                    <select
                        id={id}
                        className={selectClasses}
                        name={name}
                        value={value || ''}
                        onChange={this.handleChange}
                        disabled={disabled}
                        aria-invalid={!!error}
                    >
                        {R.map(optionMapper, options)}
                    </select>
                    {formattedError && <small className="help-block mb-none text-danger">{formattedError}</small>}
                </div>
            </div>
        );
    }
}

Select.propTypes = {
    name: pt.string.isRequired,
    label: pt.string,
    id: pt.string.isRequired,
    value: pt.oneOfType([pt.string, pt.number]),
    onChange: pt.func.isRequired,
    disabled: pt.bool.isRequired,
    options: pt.arrayOf(pt.shape({})).isRequired,
    hasEmpty: pt.bool.isRequired,
    horizontal: pt.bool,
    error: pt.oneOfType([pt.string, pt.array]),
};

Select.defaultProps = {
    disabled: false,
    value: '',
    options: [],
    hasEmpty: true,
    horizontal: true,
};

export default Select;



// WEBPACK FOOTER //
// ./src/incab/common/components/form/Select.jsx